import {IdValue} from "../../../../../../core/model/id-value";

export class TunnelTollSystemConfig {

  constructor(public username: string, public password: string, public vehicles: IdValue<string>[]) {
  }

  public static defaultValues(): TunnelTollSystemConfig {
    return new TunnelTollSystemConfig(null, null, []);
  }
}
